var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"enum":_vm.turler,"labels":_vm.turlerLabel,"rules":_vm.rules,"label":"Tebligat Türü"},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }